export default __webpack_public_path__ + "static/media/rounded-ticket-3x.b0127865.webp";